import { render, staticRenderFns } from "./WdConf.vue?vue&type=template&id=41450960&scoped=true"
import script from "./WdConf.vue?vue&type=script&lang=js"
export * from "./WdConf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41450960",
  null
  
)

export default component.exports